/* eslint-disable react-native/no-color-literals */
import COLORS from '#constants/colors';
import { BORDER_RADIUS, MARGIN_VERTICAL } from '#constants/styles';
import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  content: {
    alignItems: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  logo: {
    height: 150,
    width: 150,
  },
  logoContainer: {
    borderRadius: BORDER_RADIUS,
    marginBottom: MARGIN_VERTICAL,
    overflow: 'hidden',
  },
  page: {
    alignItems: 'center',
    backgroundColor: COLORS.CHROME_GREY,
    flexGrow: 1,
    justifyContent: 'center',
    overflow: 'hidden',
  },
});
